//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PrettyPrint from "./pretty-print.vue";
import OfferPage from "./OfferPage.vue";
import EventBus from "../eventbus.js";
import axios from 'axios';

export default {
    components:  {'pretty-print': PrettyPrint, 'offer-page': OfferPage},
    name: "contract-manager",
    computed: {
       apiUrl() {
           if (typeof process.env.VUE_APP_CMAPI !== 'undefined') {
               var url = window.location.host.replace(/(^\w+:|^)\/\//, '');
               var subdomain = url.split('.')[1] ? url.split('.')[0] : false;
               if(subdomain) {
                   return process.env.VUE_APP_CMAPI.replace("CUSTOMER", subdomain);
               }
           }

           return 'https://schuerer.eliocontract.autohaus-schuerer.de'
           //return 'http://schuerer.contract.lio'
       }
    },
    data() {
        return {
            //DEV
            backendVersion: 'unknown',
            frontendVersion: process.env.VUE_APP_CLIENT_VERSION || 'unknown',
            //END DEV
            model: {}, //Form model
            state: {}, //VueFormJsonSchema-Property
            valid: false, //VueFormJsonSchema-Property
            loaded: false, //Communication with backend in progress?
            error: true, //indicates if backend API response contained malformed information.
            errorMessage: "Ups! Hier ist etwas schief gelaufen. Bitte laden Sie diese Seite neu. Falls der Fehler weiterhin besteht, kontaktieren Sie bitte den Seitenbetreiber.",
            options: {
                castToSchemaType: true //VueFormJsonSchema-Property
            },
            formdata: null, //all backend response
            submitted: false, //VueFormJsonSchema-Property
            success: false, //VueFormJsonSchema-Property
            schema: {}, //VueFormJsonSchema-Property
            uiSchema: [], //VueFormJsonSchema-Property
            alert: false, //used for Quasar Modal
            debug: false, //debug-parameter handling
            contractId: "", //The ID of the currently displayed contract form
            parentUrl: "https://www.st.autohaus-schuerer.de"
        };
    },
    methods: {
        getBackendVersion() {
            this.$http.get(this.apiUrl + "/version").then(result => {
                this.backendVersion = result.data;
            });
        },
        runScripts() {
            if (this.formdata.currentStep.identifier === "step-2") {
                if (typeof window.AuEmbed !== "undefined") {
                    window.AuEmbed.reset();
                }

                window.AuEmbed = {
                    config: {
                        id: 'cMeGzCt19d', // Your unique configuration key
                        noDelayedCtaPage: true,
                        onValuationDone: (data) => {
                            this.loaded = false;
                            this.model["142"] = data.buyerCar;
                            this.model["143"] = data.buyerCarEstimatedMarketPrice;
                            this.model["144"] = data.buyerCarValuation;
                            this.model["145"] = data.valuationRefNo;

                            setTimeout(() => {
                                this.loaded = true;
                                setTimeout(() => {
                                    this.submitForm();
                                }, 100);
                            }, 100);
                        }, // (function) a callback executed when the customer submits the data about their car, and the price can be valuated
                        onValuationFailed: (data) => {
                            this.loaded = false;
                            this.model["142"] = {};
                            this.model["143"] = 0;
                            this.model["144"] = 0;
                            this.model["145"] = 0;

                            setTimeout(() => {
                                this.loaded = true;
                                setTimeout(() => {
                                    this.submitForm();
                                }, 100);
                            }, 100);
                        }
                    }
                };
                var d={depId:window.AuEmbed.config.departmentId,device:window.matchMedia(
                    'only screen and (max-width: 760px)').matches?'mobile':'desktop',
                      pageType:window.AuEmbed.config.pageType,
                      url:window.AuEmbed.config.previewUrl||document.location.href},
                    s = document.createElement('script');
                s.async = true;
                s.src = 'https://www.autouncle.de/de/customers/' + encodeURIComponent(window.AuEmbed.config.id)+'/website_script.js?d='+encodeURIComponent(JSON.stringify(d));
                s.id = 'au-trade-in-script';
                var h = document.getElementsByTagName('head')[0];
                h.insertBefore(s, h.lastChild);
            }
        },
        /**
         * function for initial backend api call.
         */
        getContractManagerData(id) {
            return this.$http.get(this.apiUrl + "/api/" + id);
        },

        /**
         * Helper function to extract specific URL params out of url.
         */
        getUrlParam(param) {
            return new URL(location.href).searchParams.get(param);
        },

        /**
         * function to calculate the current sections step progress, e.g. Current Step: 6/12.
         * current Step (in example: 6): this.formdata.sectionStepProgress
         * all Steps (in example: 12): this.formdata.sectionStepCount
         */
        computeStepProgress() {
            var sectionId = this.formdata.currentStep.section_id;
            var stepId = this.formdata.currentStep.id;
            var sectionSteps = this.formdata.allSteps.filter(step => step.section_id === sectionId);
            var counter = 0;
            for (; counter < sectionSteps.length; counter++) {
                if (sectionSteps[counter]['id'] === stepId) break;
            }
            this.formdata.sectionStepCount = sectionSteps.length;
            this.formdata.sectionStepProgress = counter + 1;
        },

        /**
         * this function is called initially on component creation.
         * Triggers backend api call and processes the received data for vue-json-schema to work.
         */
        getForm() {
            this.loaded = false;
            this.error = false;
            this.$q.loading.show();


            this.contractId = location.hash.substr(1, location.hash.length);

            if (typeof this.contractId === 'string' || this.contractId instanceof String) {
                this.getContractManagerData(this.contractId).then(newSchema => {
                    if (this.checkBackendData(newSchema.data)) {
                        this.formdata = newSchema.data;
                        this.computeStepProgress();
                        this.prepareNavigationSections();
                        let result = this.$convertJSONSchema(this.formdata.schema, this.formdata.payload, this.formdata.globalData);
                        this.uiSchema = result.uiSchema;
                        this.model = result.model;
                        this.schema = result.schema;
                        this.loaded = true;
                        this.runScripts();

                    } else {
                        this.loaded = true;
                        this.error = true;
                    }
                    this.$q.loading.hide();
                }, () => {
                    this.errorMessage = "Ups! Hier ist etwas schief gelaufen. Grund ist ein falscher Vertrags-Parameter.";
                    this.loaded = true;
                    this.error = true;
                    this.$q.loading.hide();
                });
            } else {
                this.errorMessage = "Ups! Hier ist etwas schief gelaufen. Grund ist ein fehlender Vertrags-Parameter.";
                this.loaded = true;
                this.error = true;
                this.$q.loading.hide();
            }
        },

        /**
         * Helper method for debugging vue-form-json-schema
         */
        onChangeState(value) {
            this.state = value;
        },

        /**
         * Helper method for debugging vue-form-json-schema
         */
        onValidated(value) {
            this.valid = value;
        },

        /**
         * Click handler for Back Button (if present in current step) of Contract Manager Form Step.
         */
        onBackButtonPressed() {
          // check if current step is the first step, in this case a punchout to the redirecting platform has to be performed
          this.checkForPunchout();

          fetch(this.apiUrl + "/api/" + this.contractId + "/navigate", {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ direction: "backward" })
          }).then(() => this.getForm());
        },

        /**
         * Click handler for Skip Button (if present in current step) of Contract Manager Form Step.
         */
        onSkipButtonPressed() {
          fetch(this.apiUrl + "/api/" + this.contractId + "/navigate", {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ direction: "forward" })
          }).then(() => this.getForm());
        },

      /**
       * Checks, if the user pressed the back button in the first step. In this case, a punchout to the redirecting platform has to be performed.
       */
        checkForPunchout() {
          if(this.formdata.hasOwnProperty("currentStep") && this.formdata.currentStep.hasOwnProperty("id") &&
              this.formdata.hasOwnProperty("allSteps") && this.formdata.allSteps.length > 0 && this.formdata.allSteps[0].hasOwnProperty("id") &&
              this.formdata.hasOwnProperty("payload") && this.formdata.payload.hasOwnProperty("back_url")) {

            let currentStepId = this.formdata.currentStep.id;
            let firstStepId = this.formdata.allSteps[0].id;

            if(currentStepId === firstStepId) {
              window.open(this.formdata.payload.back_url, "_self");
            }
          }
        },

        // takes a {} object and returns a FormData object
        objectToFormData (obj, form, namespace) {

            var fd = form || new FormData();
            var formKey;

            for(var property in obj) {
                if(obj.hasOwnProperty(property)) {

                    if(namespace) {
                        formKey = namespace + '[' + property + ']';
                    } else {
                        formKey = property;
                    }

                    // if the property is an object, but not a File,
                    // use recursivity.
                    if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                        this.objectToFormData(obj[property], fd, formKey);

                    } else {
                        // if it's a string or a File object
                        if(obj[property] instanceof File) {
                            //if file
                            fd.append(property, obj[property]);
                        } else {
                            //if string
                            fd.append(formKey, obj[property]);
                        }
                    }

                }
            }
            return fd;
        },

        performSubmitFormRequest(shouldAdvanceStep, validate) {
            var formData = this.objectToFormData(this.model, null, "payload");
            formData.append('shouldAdvanceStep', shouldAdvanceStep);
            if(validate) {
                formData.append('validate', true);
            }
            this.$http.post(this.apiUrl + "/api/" + this.contractId + "/save", formData).then((response) => {
              let body = response.data;
              if(!body.success || (body.hasOwnProperty("errors") && body.errors.length > 0)) {
                //form is invalid, print server side errors, do not reload form!
                EventBus.$emit('handleExternalErrors', body.errors);
              } else {
                this.getForm();
              }
            });
        },

        submitForm() {
            this.submitted = true;
            this.options = {
                ...this.options,
                showValidationErrors: true
            };

            if (!this.valid) {
              return;
            }

            this.success = true;
            this.options.showValidationErrors = false;
            this.performSubmitFormRequest(true, true);
        },

        /**
         * This function gets executed if the vus-form-json-schema form is submitted.
         * Checks, if form content is valid and posts results back to backend API.
         */
        onSubmit(e) {
            e.preventDefault();
            this.submitForm();
        }
        ,

        /**
         * Generates CSS classes for section list displayed in header.
         * Depending on currently active and already processed sections.
         */
        getNavigationSectionClasses(sectionOrder) {
            var currentSectionOrder = this.formdata.currentSection.order;

            if (sectionOrder < currentSectionOrder) {
                return "gt-xs passed";
            } else if (sectionOrder === currentSectionOrder) {
                return "active";
            } else {
                return "gt-xs";
            }
        }
        ,

        /**
         * Duplicates this.formdata.allSections, dropping such sections which must not be shown in the header section list.
         */
        prepareNavigationSections() {
            var allSections = this.formdata.allSections;
            this.formdata.navigationSections = allSections.filter(section => section.show_in_header === 1);
        }
        ,

        /**
         * Checks the received backend-API-response for missing information.
         */
        checkBackendData(data) {
            this.log('DATA', data);

            if (typeof data !== 'object' || data === null) {
                this.log("Response data is no object.");
                return false;
            }

            if (!data.hasOwnProperty("schema") || !data.hasOwnProperty("currentSection") || !data.hasOwnProperty("allSections") || !data.hasOwnProperty("currentStep") || !data.hasOwnProperty("allSteps") || !data.hasOwnProperty("customer")) {
                this.log("Top level property missing.");
                return false;
            }

            if (!data.currentSection.hasOwnProperty("order") || !data.currentSection.hasOwnProperty("show_jumbotron") || !data.currentSection.hasOwnProperty("jumbotron_indicator_type") || !data.currentSection.hasOwnProperty("jumbotron_indicator_content") || !data.currentSection.hasOwnProperty("jumbotron_headline") || !data.currentSection.hasOwnProperty("jumbotron_content")) {
                this.log("Current Section property missing.");
                return false;
            }

            if (!data.customer.hasOwnProperty("logoUrl") || !data.customer.hasOwnProperty("displayName")) {
                this.log("Customer property missing.");
                return false;
            }

            if (!data.currentStep.hasOwnProperty("section_id") || !data.currentStep.hasOwnProperty("id") || !data.currentStep.hasOwnProperty("show_header") || !data.currentStep.hasOwnProperty("display_name") || !data.currentStep.hasOwnProperty("description") || !data.currentStep.hasOwnProperty("back_button_text") || !data.currentStep.hasOwnProperty("show_back_button") || !data.currentStep.hasOwnProperty("skip_button_text") || !data.currentStep.hasOwnProperty("show_skip_button") || !data.currentStep.hasOwnProperty("next_button_text") || !data.currentStep.hasOwnProperty("show_next_button")) {
                this.log("CurrentStep property missing.");
                return false;
            }

            data.allSections.forEach(element => {
                if (!element.hasOwnProperty("show_in_header") || !element.hasOwnProperty("order") || !element.hasOwnProperty("display_name")) {
                    this.log("AllSections property missing.");
                    return false;
                }
            });

            data.allSteps.forEach(element => {
                if (!element.hasOwnProperty("section_id")) {
                    this.log("AllSteps property missing.");
                    return false;
                }
            });

            return true;
        }
        ,

        /**
         * Helper method for printing a message to console if debug mode is enabled.
         */
        log(message) {
            if (this.debug)
                console.log("ContractManager: " + message);
        },

        triggerRefresh() {
            this.$q.loading.show();
            setTimeout(() => {
                this.performSubmitFormRequest(false, false);
            }, 750);
        }
    },
    created() {
        if (this.getUrlParam("debug")) {
            this.debug = true;
            this.log("Debug mode enabled.");
        }

        this.getForm();
        this.getBackendVersion();
    },
    mounted() {
        EventBus.$on("skipStep", () => {
            this.onSkipButtonPressed();
        });

        EventBus.$on("submitStep", () => {
            this.submitForm();
        });

        EventBus.$on("refresh", () => {
            this.triggerRefresh();
        });
    }
}
;
